// import Layout from "../../internal/Layout.vue";
import Layout from '../../internal/Layout.vue'
import BigDataPage from './BigData.vue'
import EditEquipment from './templates/editEquipmentTemplate.vue'
import UploadDocument from './templates/uploadDocumentTemplate.vue'
import ManageServiceOrder from './components/serviceOrder/ManageServiceOrder/ManageServiceOrder.vue'
import ManageChecklistServiceOrder from './components/serviceOrder/ChecklistServiceOrder/ManageChecklistServiceOrder.vue'
import ManageCalibration from './components/serviceOrder/ManageCalibration/ManageCalibration.vue'
import ManageCalled from './components/Calleds/components/manageCalled/manageCalled.vue'

const BigDataRoutes = {
  component: Layout,
  children: [
    {
      module: 'big_data',
      name: 'bigData',
      path: '/',
      component: BigDataPage,
      meta: {
        module: 'big_data',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
      },
    },
    {
      module: 'big_data',
      name: 'bigDataEditEquipment',
      path: '/bigData-editEquipment/:equipmentId/:institutionId',
      component: EditEquipment,
      meta: {
        module: 'big_data',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
      },
    },
    {
      module: 'big_data',
      name: 'bigDataUploadDocument',
      path: '/bigData-uploadDocument',
      component: UploadDocument,
      meta: {
        module: 'big_data',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
      },
    },
    {
      module: 'big_data',
      name: 'bigDataEditServiceOrder',
      path: '/bigData-editServiceOrder/:serviceOrderId/:institutionIdProp',
      component: ManageServiceOrder,
      props: true,
      meta: {
        module: 'big_data',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
    {
      module: 'big_data',
      name: 'bigDataFormChecklist',
      path: '/bigData-formChecklist',
      component: ManageChecklistServiceOrder,
      meta: {
        module: 'big_data',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
    {
      module: 'big_data',
      name: 'bigDataFormCalibration',
      path: '/bigData-formCalibration',
      component: ManageCalibration,
      meta: {
        module: 'big_data',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
        requiresOperator: true,
        requiresCoordOp: true,
        requiresCoordSector: true,
        requiresLaboratory: true,
      },
    },
    {
      name: 'bigDataEditCalled',
      path: '/bigData-editCalled/:calledId/:institutionIdProp',
      component: ManageCalled,
      props: true,
      meta: {
        module: 'big_data',
        requiresAuth: true,
        requiresMaster: true,
        requiresAdmin: true,
        requiresSupervisor: true,
      },
    },
  ],
}

export default BigDataRoutes
